import {ajax} from 'nanoajax';

const errTexts = ['Error','Abort','Timeout'];

export  function getCss(theme){
	console.log("process.env.CSS_URL", process.env.CSS_URL);
	var baseUrl = process.env.CSS_URL;
	var url = `${process.env.CSS_URL}src/${theme}/outer.css`;
	return new Promise((resolve,reject)=>{
		ajax({url},(code,response)=>{
			if(code && (errTexts.indexOf(response) === -1)){
				resolve([code,response]);
			} else {
				reject([code,response]);
			}
		});
	});
};

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}


// WEBPACK FOOTER //
// ./Api.js